'use client';

import { Button } from '@/components/ui/button';
import { IconX } from '@tabler/icons-react';
import { FilterChip } from '@/lib/projects/project-types';

interface ActiveFilterChipsProps {
  chips: FilterChip[];
  onRemove: (chipKey: string) => void;
  onClearAll: () => void;
}

export function ActiveFilterChips({
  chips,
  onRemove,
  onClearAll,
}: ActiveFilterChipsProps) {
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          onClick={() => onRemove(chip.key)}
          className="inline-flex items-center gap-1 rounded-full bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground hover:bg-secondary/80 transition-colors max-w-[200px]"
        >
          <span className="truncate">{chip.label}</span>
          <IconX className="size-3 shrink-0" />
        </button>
      ))}
      <Button
        variant="ghost"
        size="sm"
        onClick={onClearAll}
        className="h-auto px-2 py-1 text-xs text-muted-foreground hover:text-foreground"
      >
        Clear all
      </Button>
    </div>
  );
}
